import { render, staticRenderFns } from "./InicioComponent.vue?vue&type=template&id=bcb8cdca&scoped=true&"
import script from "./InicioComponent.vue?vue&type=script&lang=js&"
export * from "./InicioComponent.vue?vue&type=script&lang=js&"
import style0 from "./InicioComponent.vue?vue&type=style&index=0&id=bcb8cdca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb8cdca",
  null
  
)

export default component.exports